"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterValidationService = void 0;
var FilterValidationService_1 = require("./implementation/FilterValidationService");
exports.filterValidationService = new FilterValidationService_1.FilterValidationService();
//# sourceMappingURL=index.js.map